import { ref as n, watch as h } from "vue";
const L = (o, u, {
  onInput: r,
  onValidityChange: v
}) => {
  const s = n(!1), t = n(!1), i = n(!1), d = n(!1), a = n(!1), f = n(0), m = () => {
    if (!s.value)
      return;
    const e = t.value;
    t.value = o.value ? !o.value?.validity?.valid : !1, e !== t.value && v && v(!t.value);
  };
  return h(u, () => {
    d.value = !0, m();
  }), {
    listeners: {
      blur: () => {
        s.value = d.value, m(), t.value || (s.value = !1), i.value = !1;
      },
      compositionend: (e) => {
        a.value && r(e), a.value = !1;
      },
      compositionstart: () => {
        a.value = !0;
      },
      focus: () => {
        i.value = !0;
      },
      input: (e) => {
        if (o.value?.type === "number") {
          const g = e.inputType === "insertText" || e.inputType === "insertFromPaste", T = e.data === "." && f.value === o.value?.value?.length, x = e.data === ",", c = e.inputType === "deleteContentBackward", p = o.value?.value?.lastIndexOf("."), y = o.value?.value?.length ?? 0, C = p !== -1 && p === y - 1, l = o.value?.value ?? "", D = c && l === "" && u.value != null && String(u.value).includes("."), E = c && l.includes(".") && String(Number(l)) !== l;
          if (g && (T || x) || c && C || D || E)
            return;
        }
        a.value || r(e);
      },
      mouseup: () => {
        f.value = o.value?.selectionEnd || 0;
      }
    },
    touched: s,
    invalid: t,
    focused: i
  };
};
export {
  L as useNativeInput
};
